import React from 'react';
import PropTypes from 'prop-types';
import { join } from 'lodash';
import { DropdownWrapper, FieldWithUnits, GridItem } from './../../common';
import { MenuItem } from '@material-ui/core';
import { ACTIVE_NUMERATOR_UNIT } from '../constants';

function ConcentrationForm({ paths }) {
  return (
    // <GridItem lg={4} xs={12}>
    <FieldWithUnits
      component={DropdownWrapper}
      id={ACTIVE_NUMERATOR_UNIT}
      label="Unit"
      name={join([...paths, ACTIVE_NUMERATOR_UNIT], '.')}
      paths={[...paths, ACTIVE_NUMERATOR_UNIT]}
      units="per mL(cc)"
    >
      <MenuItem value="mcg">mcg</MenuItem>
      <MenuItem value="mg">mg</MenuItem>
      <MenuItem value="g">g</MenuItem>
      <MenuItem value="Other">Other</MenuItem>
    </FieldWithUnits>
    // </GridItem>
  );
}

ConcentrationForm.propTypes = {
  paths: PropTypes.array,
};

ConcentrationForm.defaultProps = {
  paths: [],
};

export default ConcentrationForm;



// WEBPACK FOOTER //
// ./src/modules/MedicationPage/components/ConcentrationForm.js